<ngx-spinner></ngx-spinner>
<div class="container" style="overflow-x: scroll;">
    <h1>Resumen de Citas</h1>
    <div class="mat-elevation-z8">
        <mat-form-field>
            <mat-label>Filtro</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="identificador" #input>
        </mat-form-field>
        <table mat-table [dataSource]="dataSource" style="width: 100%">

            <ng-container matColumnDef="estatusVidellamada">
                <th mat-header-cell *matHeaderCellDef>Estatus Videollamada</th>
                <td mat-cell *matCellDef="let element"> {{element?.estatus}} </td>
            </ng-container>

            <ng-container matColumnDef="atendida">
                <th mat-header-cell *matHeaderCellDef>Atendida</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-mini-fab color="primary" (click)="changeEstatus(2, element)" [disabled]='element?.observaciones!=undefined'>
                        <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
                    </button> 
                </td>
            </ng-container>

            <ng-container matColumnDef="cancelada">
                <th mat-header-cell *matHeaderCellDef>Cancelada</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-mini-fab color="warn" (click)="changeEstatus(3, element)"  [disabled]='element?.observaciones!=undefined'>
                        <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                    </button> 
                </td>
            </ng-container>

            <ng-container matColumnDef="observacion">
                <th mat-header-cell *matHeaderCellDef>Observación</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-mini-fab color="primary" (click)="onClick(element?.observaciones)"  [disabled]='element?.observaciones==undefined'>
                        <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                    </button> 
                </td>
            </ng-container>
            
            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element"> {{element?.nombre}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Correo Electrónico</th>
                <td mat-cell *matCellDef="let element"> {{element?.email}} </td>
            </ng-container>

            <ng-container matColumnDef="telefono">
                <th mat-header-cell *matHeaderCellDef>Telefono</th>
                <td mat-cell *matCellDef="let element"> {{element?.telefono}} </td>
            </ng-container>
            
            <ng-container matColumnDef="empresa">
                <th mat-header-cell *matHeaderCellDef>Empresa</th>
                <td mat-cell *matCellDef="let element"> {{element?.empresa}} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element"> {{element?.estado}} </td>
            </ng-container>

            <ng-container matColumnDef="ocupacion">
                <th mat-header-cell *matHeaderCellDef>Ocupación</th>
                <td mat-cell *matCellDef="let element"> {{element?.ocupacion}} </td>
            </ng-container>

            <ng-container matColumnDef="medio">
                <th mat-header-cell *matHeaderCellDef>Medio</th>
                <td mat-cell *matCellDef="let element">{{element?.medio}} </td>
            </ng-container>

            <ng-container matColumnDef="descripcion">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let element"> 
                     <button mat-raised-button type="submit" color="primary" (click)="onClick(element?.descripcion)">Ver descripción</button> </td>
            </ng-container>

            <ng-container matColumnDef="fecha">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let element"> {{element?.fecha}} </td>
            </ng-container>

            <ng-container matColumnDef="hora">
                <th mat-header-cell *matHeaderCellDef>Horario</th>
                <td mat-cell *matCellDef="let element"> {{element?.hora}} </td>
            </ng-container>

            <ng-container matColumnDef="meet">
                <th mat-header-cell *matHeaderCellDef>Url Google</th>
                <td mat-cell *matCellDef="let element"> {{element?.meet}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator showFirstLastButtons></mat-paginator>
    </div>
</div>